<template>
  <div class="my-file">
    <ul class="el-upload-list el-upload-list--text">
      <li
        tabindex="0"
        v-for="item in myFileList"
        class="el-upload-list__item is-ready"
      >
        <a
          class="el-upload-list__item-name"
          :href="item.src"
          target="_blank"
          :title="item.name"
        >
          <i class="el-icon-document"></i>
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { apiConfig } from "../config/api";
export default {
  name: "MyFile",
  props: {
    fileList: {
      type: Array
    },
    preview: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    fileList(val) {
      this.initFileList(val);
    }
  },
  data() {
    return {
      myFileList: null
    };
  },
  mounted() {
    this.initFileList(this.fileList);
  },
  computed: {},
  methods: {
    async initFileList(val) {
      if (val && val.length > 0) {
        this.myFileList = [];
        for (let i = 0; i < val.length; i++) {
          let item = val[i];
          let src = apiConfig.document.api.download.url + item.docId;
          this.myFileList.push({
            name: item.name,
            src: src
          });
        }
      } else {
        this.myFileList = null;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.my-image {
  max-width: 100%;
  max-height: 100%;
}
</style>
<style lang="scss">
.my-file {
  .el-upload-list__item-name {
    margin-right: 0;
  }
}
</style>
